export default function RenderProgress(value) {
  if (parseFloat(value) == 0 || value==null) {
    return 0
  }
    if (0 < parseFloat(value) && parseFloat(value) <= 0.5) {
      return 12.5;
    }
    if (0.5 < parseFloat(value) && parseFloat(value) <= 1.0) {
      return 25;
    }
    if (1.0 < parseFloat(value) && parseFloat(value) <= 1.5) {
      return 37.5;
    }
    if (1.5 < parseFloat(value) && parseFloat(value) <= 2.0) {
      return 50;
    }
    if (2.0 < parseFloat(value) && parseFloat(value) <= 2.5) {
      return 62.5;
    }
    if (2.5 < parseFloat(value) && parseFloat(value) <= 3.0) {
      return 75;
    }
    if (3.0 < parseFloat(value) && parseFloat(value) <= 3.5) {
      return 87.5;
    }
    if (3.5 < parseFloat(value) && parseFloat(value) <= 4.0) {
      return 100;
    }
  }
  